// extracted by mini-css-extract-plugin
module.exports = {"searchLayout":"bQ"};